import { setFlexDFAIC, setRowReverse, setTextRightArabic, styled } from "theme";

type Props = {
  isArabic: boolean;
};

export const SUsersChangeRowGroupCommon = styled.div<Props>`
  margin-bottom: 10px;

  ${setFlexDFAIC};
  ${setTextRightArabic()};
  ${setRowReverse()};
`;
